import { Resource } from './resource';

export interface ISerializer<T extends Resource> {
  fromJson(json: any): T;
  toJson(resource: Resource): any;
}

export class Serializer<T extends Resource> {
  
  // constructor(protected model: T) {}

  fromJson(json: any): T {
    const data: any = {}; //new T();
    data.id = json.id;
    for (const [ key, value ] of Object.entries(json)) {
      if (value) {
        data[key] = value;
      }
    }
    return data;
  }

  toJson(data: T): any {
    const { id, ...attrs } = data;
    const payload: any = {};
    for (const [ key, value ] of Object.entries(attrs)) {
      if (value) {
        payload[key] = value;
      }
    }
    return payload;
  }

}
